import {useMemo} from 'react';
import {useUser} from "@/contexts/UserContext";
import {DodRecommendedSelectionsType, RecommendedSelections, RecommendedSelectionsSummary} from '@/types/ApiTypes';
import { getUniversalRecommendedSelection, deleteUniversalRecommendedSelection } from '@/api/dod';

export function useUniversalSelection() {

    const {dodUniversalSavedSelections, reloadDodUniversalSavedSelections} = useUser();

    const dodUniversalSelectionsMap = useMemo<Record<DodRecommendedSelectionsType, (RecommendedSelectionsSummary | RecommendedSelections)[]>>(() => {

        const { product = [], fact = [], time_period = [] } = dodUniversalSavedSelections || {};

        const sortByDisplayName = (a: RecommendedSelectionsSummary | RecommendedSelections, b: RecommendedSelectionsSummary | RecommendedSelections) =>
            a.displayName.trim().localeCompare(b.displayName.trim());

        let products = [...product].sort(sortByDisplayName);
        let timePeriods = [...time_period].sort(sortByDisplayName);
        let facts = [...fact].sort(sortByDisplayName);

        return {
            product: products,
            time_period: timePeriods,
            fact: facts,
        };
    }, [dodUniversalSavedSelections]);

    async function getUniversalRecommendedSelectionById(id: number): Promise<RecommendedSelections> {

            const {values, ...preset} = await getUniversalRecommendedSelection(id);
    
            return {
                ...preset,
                values
            };
    }

    async function deleteUniversalRecommendedSelectionById(id: number): Promise<void> {

        await deleteUniversalRecommendedSelection(id);
        // this isn't necessary we just update the map with the change
        await reloadDodUniversalSavedSelections();
    }

    return {
        dodUniversalSelectionsMap,
        getUniversalRecommendedSelectionById,
        deleteUniversalRecommendedSelectionById
    }
}
